import { render, staticRenderFns } from "./SelectMatchingRequisition.vue?vue&type=template&id=2e0a69e6&scoped=true&"
import script from "./SelectMatchingRequisition.vue?vue&type=script&lang=js&"
export * from "./SelectMatchingRequisition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a69e6",
  null
  
)

export default component.exports